import Entity from 'models/Entity';
import abortableFetch from 'services/api/abortableFetch';

export const loadEntities = (ids: string) =>
  abortableFetch<Entity[]>(
    `${process.env.REACT_APP_BACKEND_HOST}/api/entities/${ids}`,
  );
